import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import {routerShape, withRouter} from 'react-router';

import {withI18n} from 'spa/Components/Context';
import {browserOnly} from 'spa/Components/EnvSplit';

import Button, { ButtonSizeTypes, ButtonThemeTypes, ButtonType } from '@urbanmassage/component-library/lib/Button/Button';
import CartWithCountButton from '../CartWithCountButton';

import ProgressiveImage from 'spa/Components/ProgressiveImage';

import './booking-header.less';

const BookingHeader = ({
  basketNew,
  router,
}, { i18n }) => {
  basketNew.getBasketSummary();

  const clickLeaveBooking = (event) => {
    if (event) event.preventDefault();

    // TODO Add leave flow confirmation popup
    router.push(`/${i18n.lc}/`);

    // tracker.track('User triggered leave booking flow popup', {
    //   category: 'Booking',
    //   label: bookingScreen,
    // });
  };

  return (
    <header className="booking-header" data-testid="booking-header-container">
      <div className="booking-header__logo-button-container">
        <Button
          aria-label={i18n._x('Leave Booking flow', 'Booking Header')}
          block
          data-testid="booking-header-logo-button"
          onClick={clickLeaveBooking}
          type={ButtonType.button}
          size={ButtonSizeTypes.default}
          theme={ButtonThemeTypes.transparent}
        >
          <ProgressiveImage
            disableWebp
            lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/q_15,e_blur:2000/v1656510511/b2c-art/logo/logo_dark.svg"
            highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/v1656510511/b2c-art/logo/logo_dark.svg"
            alt=""
            width="120"
          />
        </Button>
      </div>
      <div className="booking-header__basket-button-container">
        <CartWithCountButton />
      </div>
    </header>
  );
};

BookingHeader.propTypes = {
  basketNew: PropTypes.shape({
    basketFormattedAddress: PropTypes.string,
    basketHasAddress: PropTypes.bool,
    basketHasStartsAt: PropTypes.bool,
    basketHasWorker: PropTypes.bool,
    basketServiceCount: PropTypes.number,
    getBasketSummary: PropTypes.func.isRequired,
  }).isRequired,
  router: routerShape.isRequired,
};

export default withRouter(inject(({
  store: {
    basketNew,
  },
}) => ({
  basketNew,
}))(browserOnly(observer(withI18n(BookingHeader)))));



// WEBPACK FOOTER //
// ./spa/Pages/BookingNext/Components/BookingHeader/BookingHeader.jsx